import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16b06db0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-px-[20px] tw-pt-[20px] tw-pb-[10px] tw-flex tw-items-center tw-justify-between tw-h-[46px]" }
const _hoisted_2 = { class: "tw-text-base tw-font-semibold tw-w-full tw-text-[#211F58]" }
const _hoisted_3 = { class: "tw-p-[15px] tw-w-[247px]" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = { class: "tw-flex tw-items-center" }
const _hoisted_6 = { class: "title-note" }
const _hoisted_7 = { class: "tw-mt-[10px] tw-text-[11px] tw-font-[400] tw-text-[#878787]" }
const _hoisted_8 = {
  key: 0,
  class: "tw-flex tw-w-full tw-h-[134px]"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-global-skeleton tw-w-full tw-h-full" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "tw-px-[20px] tw-py-4 tw-flex tw-items-center tw-justify-between tw-h-[45px]"
}
const _hoisted_12 = { class: "tw-text-[12px] tw-font-medium" }
const _hoisted_13 = { class: "tw-text-[13px] tw-font-semibold tw-text-[#878787]" }
const _hoisted_14 = {
  key: 2,
  class: "tw-px-[20px] tw-py-4 tw-flex tw-items-center tw-justify-between tw-border-t-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] tw-h-[45px]"
}
const _hoisted_15 = { class: "tw-text-[12px] tw-font-medium" }
const _hoisted_16 = { class: "tw-text-[13px] tw-font-semibold tw-text-[#878787]" }
const _hoisted_17 = { class: "tw-px-[20px] tw-py-4 tw-flex tw-items-center tw-justify-between tw-border-t-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] tw-h-[45px]" }
const _hoisted_18 = { class: "tw-text-[12px] tw-font-medium" }
const _hoisted_19 = { class: "tw-text-[16px] tw-font-semibold tw-text-[#01893D]" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[14px] tw-mr-[3px] tw-font-medium" }, "+", -1))
const _hoisted_21 = { class: "tw-text-[16px] tw-font-semibold tw-text-[#F7553C]" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[14px] tw-mr-[3px] tw-font-medium" }, "-", -1))

import { PropType, computed } from "vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import { getComponentUiText } from "@/utils/utilities";
import CalendarIcon from "@/components/svgs/calendarIcon.vue";

export type dataScore = {
  title: string;
  id: string;
  value: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'cyberHealthScore',
  props: {
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
  score: {
    type: Object,
    required: true,
    default: () => ({
      currentSCore: 425,
      maxScore: 40,
    }),
  },
  data: {
    type: Array as () => dataScore[],
    required: true,
    default: () => [
      {
        title: getComponentUiText(
          "app-assess-recommendations-cyber-health-score-sub-title-1",
        ),
        id: "currentScore",
        value: 425,
      },
      {
        title: getComponentUiText(
          "app-assess-recommendations-cyber-health-score-sub-title-2",
        ),
        id: "potentialScore",
        value: 40,
      },
    ],
  },
  title: {
    type: String,
    default: "",
    required: false,
  },
  noteTitle: {
    type: String,
    default: null,
    required: false,
  },
  noteDescription: {
    type: String,
    default: null,
    required: false,
  },
  type: {
    type: String as PropType<"cyberHealthScore" | "scoreIncrease">,
    required: false,
    default: "cyberHealthScore",
  },
},
  setup(__props) {

const props = __props;



const scoreIncrease = computed(() => {
  return props.type == "scoreIncrease"
    ? Math.round(+props.score.maxScore) - Math.round(+props.score.currentSCore)
    : (props.score.maxScore - props.score.currentSCore).toString();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "header", {}, () => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
        _createVNode(ButtonShowDuplicateAssessment, {
          "id-popover": 'popover-cyber-health-score',
          class: _normalizeClass(`tw-p-[15px]`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(CalendarIcon)
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(__props.noteTitle ??
                _unref(getComponentUiText)(
                  "app-assess-recommendations-cyber-health-score-note-title-1",
                )), 1)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(__props.noteDescription ??
              _unref(getComponentUiText)(
                "app-assess-recommendations-cyber-health-score-description-1",
              )), 1)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true),
    (!__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(__props.data[0].title), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(__props.type === "scoreIncrease"
          ? Math.round(+__props.score.currentSCore)
          : Number(__props.score.maxScore)), 1)
        ]))
      : _createCommentVNode("", true),
    (!__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(__props.data[1].title), 1),
          _createElementVNode("div", _hoisted_16, _toDisplayString(__props.type === "scoreIncrease"
          ? Math.round(+__props.score.maxScore)
          : Number(__props.score.maxScore)), 1)
        ]))
      : _createCommentVNode("", true),
    (!__props.isLoading)
      ? _renderSlot(_ctx.$slots, "footer", { key: 3 }, () => [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(getComponentUiText)(
            "app-assess-recommendations-cyber-health-score-sub-title-3",
          )), 1),
            _withDirectives(_createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("span", null, _toDisplayString(scoreIncrease.value), 513), [
                [_vShow, Number(scoreIncrease.value) === 0]
              ]),
              _withDirectives(_createElementVNode("span", null, [
                _hoisted_20,
                _createTextVNode(_toDisplayString(scoreIncrease.value), 1)
              ], 512), [
                [_vShow, Number(scoreIncrease.value) > 0]
              ])
            ], 512), [
              [_vShow, Number(scoreIncrease.value) >= 0]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("span", null, [
                _hoisted_22,
                _createTextVNode(_toDisplayString(scoreIncrease.value.toString().replace("-", "")), 1)
              ], 512), [
                [_vShow, Number(scoreIncrease.value) < 0]
              ])
            ], 512), [
              [_vShow, Number(scoreIncrease.value) < 0]
            ])
          ])
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})